import type { JobApplication, Opportunity } from '../types/campus'

export const opportunities: Opportunity[] = [
  {
    id: 'opp-1',
    title: 'Data Engineering Intern',
    employer: 'Paystack',
    kind: 'Internship',
    location: 'Lagos',
    arrangement: 'Hybrid',
    stipend: '₦250,000 / month',
    deadlineLabel: 'Closes 28 Aug',
    skills: ['SQL', 'Python', 'Data modelling'],
    employerVerified: true,
  },
  {
    id: 'opp-2',
    title: 'Graduate Systems Analyst',
    employer: 'Dangote Industries',
    kind: 'Graduate role',
    location: 'Lagos',
    arrangement: 'On site',
    stipend: '₦480,000 / month',
    deadlineLabel: 'Closes 15 Sep',
    skills: ['Operations research', 'Excel', 'Process mapping'],
    employerVerified: true,
  },
  {
    id: 'opp-3',
    title: 'Product Analyst Intern',
    employer: 'Havazon Works',
    kind: 'Internship',
    location: 'Remote',
    arrangement: 'Remote',
    stipend: '₦300,000 / month',
    deadlineLabel: 'Closes 3 Sep',
    skills: ['Analytics', 'SQL', 'Product sense'],
    employerVerified: true,
  },
  {
    id: 'opp-4',
    title: 'NNPC Undergraduate Scholarship',
    employer: 'NNPC Foundation',
    kind: 'Scholarship',
    location: 'Nationwide',
    arrangement: 'Remote',
    stipend: '₦500,000 / year',
    deadlineLabel: 'Closes 30 Sep',
    skills: ['CGPA 3.5+', 'Engineering discipline'],
    employerVerified: true,
  },
  {
    id: 'opp-5',
    title: 'Campus Brand Ambassador',
    employer: 'Unlisted recruiter',
    kind: 'Part-time',
    location: 'Akoka',
    arrangement: 'On site',
    stipend: '₦60,000 / month',
    deadlineLabel: 'Closes 20 Aug',
    skills: ['Communication', 'Social media'],
    employerVerified: false,
  },
  {
    id: 'opp-6',
    title: 'Maintenance Engineering Intern',
    employer: 'Nigerian Breweries',
    kind: 'Internship',
    location: 'Ibadan',
    arrangement: 'On site',
    stipend: '₦180,000 / month',
    deadlineLabel: 'Closes 12 Sep',
    skills: ['Mechanical systems', 'Reliability', 'Reporting'],
    employerVerified: true,
  },
]

export const jobApplications: JobApplication[] = [
  {
    id: 'japp-1',
    opportunityId: 'opp-1',
    title: 'Data Engineering Intern',
    employer: 'Paystack',
    submitted: '2 Aug 2026',
    stage: 'Interview',
  },
  {
    id: 'japp-2',
    opportunityId: 'opp-3',
    title: 'Product Analyst Intern',
    employer: 'Havazon Works',
    submitted: '7 Aug 2026',
    stage: 'In review',
  },
  {
    id: 'japp-3',
    opportunityId: 'opp-6',
    title: 'Maintenance Engineering Intern',
    employer: 'Nigerian Breweries',
    submitted: '11 Aug 2026',
    stage: 'Submitted',
  },
]

export const careerProfile = {
  headline: 'Systems engineering student — operations research and data',
  completeness: 72,
  skills: ['Python', 'SQL', 'Linear programming', 'Simulation', 'Technical writing'],
  missing: ['Portfolio project', 'Referee details'],
  cvUpdated: '4 Aug 2026',
}
